import { baseApi } from "shared/api";

export const teamsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query<any[], void>({
      query: () => ({
        url: `/teams/all-users`,
        method: "GET",
      }),
      keepUnusedDataFor: 16000,
    }),
    getTeamLead: builder.query<any[], string>({
      query: (id) => ({
        url: `/teams/teamlead/${id}`,
        method: "GET",
      }),
      keepUnusedDataFor: 16000,
    }),
    getAllTeams: builder.query<Array<any>, string>({
      query: (cursor) => ({
        url: `/teams/all/${cursor}`,
        method: "GET",
      }),
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newItems) => {
        currentCache.push(...newItems);
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg && currentArg !== "";
      },
      providesTags: [{ type: "Teams", id: "LIST" }],
    }),
    getAllTeamsBySearchString: builder.query<Array<any>, string>({
      query: (searchString) => ({
        url: `/teams/all/${searchString}`,
        method: "GET",
      }),
      providesTags: [{ type: "Teams", id: "SEARCH" }],
    }),
    createTeam: builder.mutation<any, any>({
      query: (team) => ({
        url: "/teams/create",
        method: "POST",
        body: { ...team },
      }),
      onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        queryFulfilled
          .then((data) =>
            dispatch(
              teamsApi.util.updateQueryData(
                "getAllTeams",
                `${getState().api.queries.getAllTeams?.originalArgs}`,
                (draft) => {
                  return [data.data, ...draft];
                }
              )
            )
          )
          .catch((er) => console.log(er));
      },
    }),
    deleteTeamById: builder.mutation<any, string>({
      query: (id) => ({
        url: `/teams/${id}`,
        method: "DELETE",
      }),
      onQueryStarted(id, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((data) =>
          dispatch(
            teamsApi.util.updateQueryData(
              "getAllTeams",
              `${getState().api.queries.getAllTeams?.originalArgs}`,
              (draft) => {
                return draft.filter((item) => item.id !== id);
              }
            )
          )
        );
      },
    }),
    deleteTeamUserById: builder.mutation<any, any>({
      query: ({ teamId, id }) => ({
        url: `/teams/delete-user/${teamId}`,
        method: "DELETE",
        body: { userId: id },
      }),
      onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        queryFulfilled
          .then((data) =>
            dispatch(
              teamsApi.util.updateQueryData(
                "getTeamById",
                `${arg.teamId}`,
                (draft) => {
                  return {
                    ...draft,
                    users: draft.users.filter(
                      (i: any) => i.id !== data.data.userId
                    ),
                  };
                }
              )
            )
          )
          .catch((er) => console.log(er));
      },
    }),
    addTeamUserById: builder.mutation<any, any>({
      query: ({ teamId, users }) => ({
        url: `/teams/add-users/${teamId}`,
        method: "PUT",
        body: { users },
      }),
      onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        queryFulfilled
          .then((data) =>
            dispatch(
              teamsApi.util.updateQueryData(
                "getTeamById",
                `${arg.teamId}`,
                (draft) => {
                  console.log(data.data);
                  return {
                    ...draft,
                    users: data.data,
                  };
                }
              )
            )
          )
          .catch((er) => console.log(er));
      },
    }),
    editTeamById: builder.mutation<any, any>({
      query: ({ teamId, data }) => ({
        url: `/teams/edit/${teamId}`,
        method: "PUT",
        body: { data },
      }),
      onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        queryFulfilled
          .then((data) =>
            dispatch(
              teamsApi.util.updateQueryData(
                "getTeamById",
                `${arg.teamId}`,
                (draft) => {
                  console.log(data.data);
                  return {
                    ...draft,
                    name: data.data.name,
                    teamLeadId: data.data.teamLeadId,
                  };
                }
              )
            )
          )
          .catch((er) => console.log(er));
      },
    }),
    getTeamById: builder.query<any, string>({
      query: (id) => ({
        url: `/teams/${id}`,
        method: "GET",
      }),
      providesTags: (res, _, arg) => [{ type: "Teams", id: arg }],
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetTeamLeadQuery,
  useCreateTeamMutation,
  useGetAllTeamsQuery,
  useLazyGetAllTeamsBySearchStringQuery,
  useDeleteTeamByIdMutation,
  useGetTeamByIdQuery,
  useDeleteTeamUserByIdMutation,
  useAddTeamUserByIdMutation,
  useEditTeamByIdMutation,
} = teamsApi;
